import { HTTPVerbs, RequestOptions } from '@nextgen-web-framework/core';
import {
  CheckoutId,
  PaymentId,
  OrderId,
  Get_Checkout_API_Version,
  Create_Checkout_API_Version,
  Place_Order_API_Version,
  Create_Payment_API_Version,
  Update_Payment_API_Version,
  Confirm_Delivery_Option_API_Version,
  Update_Delivery_Option_API_Version,
  Get_Checkout_Profile_API_Version,
  Get_Checkout_Tax_Documents_API_Version,
  Update_Checkout_API_Version,
  Profile_CITY,
  Profile_STATE,
  Search_Amway_Period_API_Version,
  PeriodId,
  Update_Amway_Period_API_Version,
} from './checkoutApiConstants';

export const getCheckoutDetailsReqObj: RequestOptions = {
  url: `/comcheckoutas/${Get_Checkout_API_Version}/checkouts/${CheckoutId}`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const createCheckoutDetailsReqObj: RequestOptions = {
  url: `/comcheckoutas/${Create_Checkout_API_Version}/checkouts`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const updateCheckoutDetailsReqObj: RequestOptions = {
  url: `/comcheckoutas/${Update_Checkout_API_Version}/checkouts/${CheckoutId}`,
  method: HTTPVerbs.PATCH,
  retries: 0,
};

export const placeOrderReqObj: RequestOptions = {
  url: `/comcheckoutas/${Place_Order_API_Version}/checkouts/${CheckoutId}/place-order`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const createPaymentReqObj: RequestOptions = {
  url: `/comcheckoutas/${Create_Payment_API_Version}/checkouts/${CheckoutId}/payments`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const updatePaymentReqObj: RequestOptions = {
  url: `/comcheckoutas/${Update_Payment_API_Version}/checkouts/${CheckoutId}/payments/${PaymentId}`,
  method: HTTPVerbs.PUT,
  retries: 0,
};

export const confirmDeliveryOptionReqObj: RequestOptions = {
  url: `/comcheckoutas/${Confirm_Delivery_Option_API_Version}/checkouts/${CheckoutId}/fulfillments`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const updateDeliveryOptionReqObj: RequestOptions = {
  url: `/comcheckoutas/${Update_Delivery_Option_API_Version}/checkouts/${CheckoutId}/fulfillments/{FulfillmentId}`,
  method: HTTPVerbs.PATCH,
  retries: 0,
};

export const getCheckoutProfileReqObj: RequestOptions = {
  url: `/comcheckoutas/${Get_Checkout_Profile_API_Version}/profiles`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const getDaneCode: RequestOptions = {
  url: `/comcontactas/${Get_Checkout_Profile_API_Version}/daneCode?city=${Profile_CITY}&state=${Profile_STATE}`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const getCheckoutByOrderIdReqObj: RequestOptions = {
  url: `/comcheckoutas/${Get_Checkout_API_Version}/checkouts?orderId=${OrderId}`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const getTaxDocumentsReqObj: RequestOptions = {
  url: `/comcheckoutas/${Get_Checkout_Tax_Documents_API_Version}/checkouts/${CheckoutId}/tax-documents`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const searchAmwayPeriodReqObj: RequestOptions = {
  url: `/comcheckoutas/${Search_Amway_Period_API_Version}/amway-periods/items`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const updateAmwayPeriodReqObj: RequestOptions = {
  url: `/comcheckoutas/${Update_Amway_Period_API_Version}/amway-periods/${PeriodId}`,
  method: HTTPVerbs.PUT,
  retries: 0,
};
